module.exports = __webpack_public_path__ + "img/rep.8afefc3f.svg";